// removed by extract-text-webpack-plugin
module.exports = {"body":"_1fJa4bpQ-ej0R5OnHCqTuU","main":"_1JVc_AD5zPrDy0-rRXLFL0","footer":"Ldy3WMo3joUrzSi-_-xai","logo":"_1JaZtc9QJzxjtdWvyHaAuf","layer":"E3V6ultp6NnA7xIDtTUq_","formLayer":"_1TPLDQkjgxDSuA_YDWOWMV","pic":"_1Rb1dwUcFy8xob9ewLpl-O"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexLayer.less
// module id = 347
// module chunks = 0